import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ExportStartedModel } from './export-started.model';
import { PresenterType } from '@app/shared';

@PresenterType({
  model: ExportStartedModel,
})

@Component({
  selector: 'export-started-message',
  standalone: false,
  templateUrl: './export-started-message.component.html',
  styleUrl: './export-started-message.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ExportStartedMessageComponent {

}
